import React, { FC } from 'react'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import IconStarFilled from '@ucheba/ui/icons/icon__star-filled.svg'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import styled from 'styled-components'
import { IProgramPageChips } from '../types'

const ChipContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;

  span {
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.7);
  }
`

const ProgramPageChips: FC<IProgramPageChips> = (props) => {
  const { type, feedbackStats } = props

  if (!type && !feedbackStats) return null

  return (
    <Grid spacing='xxsmall'>
      {feedbackStats && !!feedbackStats?.total && (
        <GridCol width='auto'>
          <Chips color='orange'>
            <ChipContent>
              <IconStarFilled width='19px' height='18px' />

              <Text fontSize='h5' lineHeight='h4' color='white'>
                {feedbackStats?.total}
              </Text>

              {feedbackStats?.score && (
                <span>
                  {feedbackStats?.score}{' '}
                  {p11n(feedbackStats?.score, 'отзыв', 'отзыва', 'отзывов')}
                </span>
              )}
            </ChipContent>
          </Chips>
        </GridCol>
      )}

      <GridCol width='auto'>
        <Chips color='blue'>
          <Text firstLetterUppercase>{type?.name}</Text>
        </Chips>
      </GridCol>
    </Grid>
  )
}

export default ProgramPageChips
